import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setMsg
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function ConfirmModalController() {
    this.title = ''
    this.msg = '';
    this.busModal = mitt();

    this.callbackOk = null;
    this.callbackCancel = null;

    //#region setter
    this.clearModal = function () {
        this.title = ''
        this.msg = '';
        this.callbackOk = null;
        this.callbackCancel = null
        return this;
    }
    this.setTitle = function (title) {
        this.title = title;
        return this;
    }
    this.setMsg = function (msg) {
        this.msg = msg;
        return this;
    }
    //#endregion setter

    //#region method
    this.show = function (opts = {}) {
        var config = {
            title: this.title,
            msg: this.msg,
            ...opts
        };
        this.busModal.emit('show', config);
    };
    this.hide = function () {
        this.busModal.emit('hide');
    }
    //#endregion method

    //#region event
    this.onClickOk = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
        return this
    }
    this.onClickCancel = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackCancel = callback;
        }
        return this
    }

    this.sendCallbackOk = function (data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    }
    this.sendCallbackCancel = function (data) {
        if (Util.isFunction(this.callbackCancel)) {
            this.callbackCancel(data);
        }
    }
    //#endregion event
}
